import ReactHtmlParser from "react-html-parser";

export default (sopParameters) => ReactHtmlParser(
  `<div>
  <h2>SSD Linehaul Pending Tdr</h2>
  <h3>Description</h3>
  <p>This disruption occurs when an outbound SSD truck has broken the delivery station's geofence but has not been docked within the TDR process.</p>
  <h3>SOP</h3>
  <ul>
    <li><b>At Risk (Yellow):</b> This proactive signal is to alert the site that there is a VRID onsite and an upcoming action to TDR.</li>
    <li><b>Critical (Red):</b> Complete the TDR process right away and this exception will resolve.</li>
    <li><b>Late (Orange):</b> Fill out notes as to why TDR did not happen per the SOP and complete the TDR process to resolve the exception.</li>
  </ul>
</div>`
);



// WEBPACK FOOTER //
// ./src/components/taskExecution/TaskSOP/FallbackSOPWiki/SSD_LINEHAUL_PENDING_TDR.jsx